export default "__VITE_ASSET__C9x_7BNc__"